export default __webpack_public_path__ + "static/media/users.f784f909.svg";